import React, { useEffect, useRef, useState } from 'react';
import { bool, string } from 'prop-types';
import { clickEvent, loadEvent } from '../../publisher';
import { getPaymentEstimatorDetails } from '../../utils';
import { ApplyNowModal } from '../apply-now-modal/apply-now-modal.component';
import './payment-estimator.style.scss';

export const PaymentEstimator = ({ isMobile, price, isAppliance }) => {
  const modalRef = useRef({});
  const [displayModal, setDisplayModal] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);

  function updatePaymentEstimatorDetails() {
    setPaymentDetails(getPaymentEstimatorDetails(price, isMobile, isAppliance));
  }

  useEffect(() => {
    loadEvent('plcc-est');
    updatePaymentEstimatorDetails();
  }, [price]);

  if (!paymentDetails) {
    return null;
  }

  const {
    activeEndDate, activeStartDate, applyNowUrl, displayPrice, promotionTerm,
  } = paymentDetails;

  const closeModal = () => {
    setDisplayModal(false);
  };

  return (
    <div className="buybox-credit-promo-message payment-estimator-wrapper">
      <div className="payment-estimator-separator-wrapper">
        <hr className="payment-estimator-separator-spacing" />
        <span className="payment-estimator-separator">OR</span>
      </div>
      <div className="payment-estimator-message">
        <span className="monthly-payment">
          <span className="monthly-payment-currency-cents">$</span>
          <span className="monthly-payment-price">{displayPrice}</span>
          <span className="monthly-payment-currency-cents">00</span>
        </span>
        <div>
          <div className="payment-estimator-text">
            <span className="u__bold">per month* suggested payments </span>
            with {promotionTerm} months* financing on this
            ${price} purchase*
            <div className="u__inline credit-info-icon-wrapper" ref={modalRef}>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <span
                onClick={setDisplayModal}
                onKeyDown={setDisplayModal}
                role="button"
                tabIndex={0}
                id="credit-info-icon"
                className="credit-info-icon"
              />
              {displayModal
              && (
                <ApplyNowModal
                  applyNowUrl={applyNowUrl}
                  closeModal={closeModal}
                  price={price}
                  isMobile={isMobile}
                  monthlyPayment={displayPrice}
                  promotionTerm={promotionTerm}
                />
              )}
            </div>
            {(!!activeStartDate)
            && (
              <>
                <br />
                VALID: {activeStartDate} - {activeEndDate}
              </>
            )}
          </div>
          <div className="apply-now-link">
            <a
              href={applyNowUrl}
              id="credit-promo-apply-now"
              className="u__default-link"
              target="blank"
              onClick={() => clickEvent('plcc-est')}
            >
              Apply for a Home Depot Consumer Card
            </a>
          </div>
        </div>
      </div>
    </div>

  );
};

PaymentEstimator.displayName = 'PaymentEstimator';

PaymentEstimator.propTypes = {
  isMobile: bool,
  price: string.isRequired,
  isAppliance: bool
};

PaymentEstimator.defaultProps = {
  isMobile: false,
  isAppliance: false
};
